import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = {
  key: 6,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  class: "acoes-item",
  style: {"margin-top":"2px"}
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-top":"10px","margin-bottom":"0"}
}, null, -1)
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = {
  key: 0,
  class: "ant-col",
  style: {"flex":"auto 1 1"}
}
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = {
  key: 1,
  class: "ant-col ant-col-xs-24",
  style: {"margin-top":"5px"}
}
const _hoisted_19 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_nota_fiscal_detalhe_pagamento_modal = _resolveComponent("nota-fiscal-detalhe-pagamento-modal")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!

  return (_openBlock(), _createBlock(_component_a_skeleton, {
    loading: _ctx.telaBase.carregando,
    paragraph: { rows: 4 }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_a_table, {
          columns: _ctx.state.colunasGrade.filter(item => item.visible),
          "data-source": _ctx.computedDetalhesPagamento,
          rowKey: "numeroTitulo",
          pagination: false,
          scroll: { y: 220 },
          size: "small"
        }, {
          emptyText: _withCtx(() => [
            _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum detalhe de pagamento adicionado ainda" })
          ]),
          bodyCell: _withCtx(({ column, record, index }) => [
            (column.key === 'acoes')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("a", {
                    class: "visualizar",
                    onClick: ($event: any) => (_ctx.editarDetalhe(index))
                  }, [
                    _createVNode(_component_icone, { nome: "editar" })
                  ], 8, _hoisted_2),
                  (_ctx.props.editavel)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "excluir",
                        onClick: ($event: any) => (_ctx.excluirDetalhe(index))
                      }, [
                        _createVNode(_component_icone, { nome: "excluir" })
                      ], 8, _hoisted_3))
                    : _createCommentVNode("", true)
                ]))
              : (column.key === 'data')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.data)), 1))
                : (column.key === 'valorPagamento')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorPagamento, 2, true)), 1))
                  : (column.key === 'acrescimos')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.acrescimos, 2, true)), 1))
                    : (column.key === 'outrasTaxas')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.outrasTaxas, 2, true)), 1))
                      : (column.key === 'valorTotal')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal, 2, true)), 1))
                        : (column.key === 'detalheMobile')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("span", null, [
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.editarDetalhe(index))
                                }, "Título: " + _toDisplayString(record.numeroTitulo), 9, _hoisted_10)
                              ]),
                              _createElementVNode("span", null, "Documento: " + _toDisplayString(record.descricaoTipoDocumentoFinanceiro), 1),
                              _createElementVNode("span", null, "Vencimento: " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.data)), 1),
                              _createElementVNode("span", null, "Valor: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal, 2, true)), 1),
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("a", {
                                  class: "visualizar",
                                  onClick: ($event: any) => (_ctx.editarDetalhe(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "editar" })
                                ], 8, _hoisted_12),
                                (_ctx.props.editavel)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "excluir",
                                      onClick: ($event: any) => (_ctx.excluirDetalhe(index))
                                    }, [
                                      _createVNode(_component_icone, { nome: "excluir" })
                                    ], 8, _hoisted_13))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source"]),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          (!_ctx.state.telaMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_a_form_item, {
                    label: " ",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.props.editavel)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.adicionarDetalhe && _ctx.adicionarDetalhe(...args)))
                          }, "Inserir pagamento"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_ctx.props.editavel)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                      style: {"width":"100%"},
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.adicionarDetalhe && _ctx.adicionarDetalhe(...args)))
                    }, "Inserir pagamento"))
                  : _createCommentVNode("", true)
              ])),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_a_form_item, {
              label: "Quantidade",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input",
                  style: {"text-align":"right"},
                  value: _ctx.computedDetalhesPagamento.length,
                  disabled: "true"
                }, null, 8, _hoisted_20)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_a_form_item, {
              label: "Total",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_campo_numerico, {
                  quantidadeCasasDecimais: 2,
                  valor: _ctx.calcularTotal(),
                  disabled: true
                }, null, 8, ["valor"])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_nota_fiscal_detalhe_pagamento_modal, {
          classeCss: "ss-modal-financeiro",
          visivel: _ctx.state.exibirLancamento,
          "onUpdate:visivel": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.exibirLancamento) = $event)),
          empresa: _ctx.props.empresa,
          detalhePagamento: _ctx.state.detalheSelecionado,
          detalhesPagamento: _ctx.state.detalhesSelecionados,
          editavel: _ctx.props.editavel,
          formaPagamento: _ctx.state.formaPagamento,
          onSalvar: _ctx.confirmarDetalhes
        }, null, 8, ["visivel", "empresa", "detalhePagamento", "detalhesPagamento", "editavel", "formaPagamento", "onSalvar"])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}